import { Directive, Input } from '@angular/core';
import { SpacingName } from '../../values/sizes';
import { spacing } from '../../extractors/sizes';
import { _DesignSystemStyleDirective, _setTokenMapper } from '../_design-system-style.directive';
import { TokenMap } from '../../core/token-mapping';

/**
 * Angular directive for applying spacing design tokens to CSS properties with type safety.
 *
 * This directive allows you to apply spacing tokens from the design system directly in templates
 * for properties like padding, margin, gap, etc. All spacing values follow the design system scale.
 *
 * @selector `[pSpacing]`
 * @standalone
 *
 * @example
 * ```html
 * <!-- Apply padding and margin -->
 * <div [pSpacing]="{
 *   'padding': 'md',
 *   'margin-bottom': 'lg'
 * }">
 *   Content with design system spacing
 * </div>
 *
 * <!-- Grid gaps -->
 * <div class="grid" [pSpacing]="{ 'gap': 'sm' }">
 *   Grid items
 * </div>
 * ```
 *
 * @example
 * ```typescript
 * spacingConfig = {
 *   'padding-top': 'lg' as const,
 *   'padding-bottom': 'md' as const,
 *   'margin': 'sm' as const
 * };
 * ```
 */
@Directive({
    standalone: true,
    selector: '[pSpacing]',
    hostDirectives: [{ directive: _DesignSystemStyleDirective, inputs: ['tokenMap:pSpacing'] }]
})
export class SpacingDirective {
    @Input() public pSpacing!: TokenMap<SpacingName>;

    constructor() {
        _setTokenMapper(spacing);
    }
}
